export default function resumeFetchDetails(
  initialState = {
    resumeData: null,
    userDetails: null,
    projectDetails: null,
    educationDetails: null,
    employmentDetails: null
  },
  action
) {
  switch (action.type) {
    case 'SET_RESUME_DATA':
      return {
        ...initialState,
        resumeData: action.payload
      };
    case 'SET_USER_DETAILS':
      return {
        ...initialState,
        userDetails: action.payload
      };
    case 'SET_PROJECT_DETAILS':
      return {
        ...initialState,
        projectDetails: action.payload
      };
    case 'SET_EDUCATION_DETAILS':
      return {
        ...initialState,
        educationDetails: action.payload
      };
    case 'SET_EMPLOYMENT_DETAILS':
      return {
        ...initialState,
        employmentDetails: action.payload
      };

    case 'RESET_ALL_DATA':
      return {
        ...initialState,
        resumeData: null,
        userDetails: null,
        projectDetails: null,
        educationDetails: null,
        employmentDetails: null
      };
    case 'RESET_ALL_DETAILS':
      return {
        ...initialState,    
        userDetails: null,
        projectDetails: null,
        educationDetails: null,
        employmentDetails: null
      };

    default:
      return initialState;
  }
}
